

















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from "vue-property-decorator";
import BasicComponent from "@/global/BasicComponent";
import {AddressDto} from "@swagger";
import CountryEnum = AddressDto.CountryEnum;

@Component({
  components: {}
})
export default class AddressInput extends BasicComponent {

  @Prop(Object) readonly address!: AddressDto;

  sendToInstitution = !!this.address.institution;

  get ownRules(): Record<any, (any) => boolean|string> {
    return {
      zipCode: (value) => {
        const postalCode = value?.trim();
        return ([4,5].includes(postalCode?.length) && !isNaN(Number(postalCode))) || this.t("CHECKOUT_ADDRESS_INVALID_POSTALCODE");
      },
    }
  }

  mounted() {
  }

  onStreetChange(newVal: string, oldVal: string) {
    console.log("onStreetChange", newVal, oldVal);
    if (oldVal == null || oldVal?.length === 0) {
      /** Split the street from house number, given autocompleted line1
       * The following formats are possible:
       "Some Street 59A" -> "Some Street", "59A"
       "Some Street 59-69" -> "Some Street", "59-69"
       "Some Street 1.1" -> "Some Street", "1.1"
       "6' Street 45b" -> "6' Street", "45b"
       "6' Some street 324/326 A/1" -> "6' Some street", "324/326 A/1"
       "Some Street 65 A/1" -> "Some Street", "65 A/1"
       "42th Stack ave. 59-69" -> "42th Stack ave.", "59-69"
       */
      const street = newVal.match(/^(.*?)(\d.*\d|\d+)(\s.*)?$/);
      if (street) {
        this.address.street = street[1].trim();
        this.address.houseNumber = street[2].trim();
      }
    }
  }

  get countries() {
    return [
      {
        text: "Österreich",
        value: CountryEnum.AUSTRIA,
      },
      {
        text: "Deutschland",
        value: CountryEnum.GERMANY,
      },
    ];
  }

  get validatePostalCode() {
    return this.ownRules.zipCode(this.address.postalCode) === true;
  }

  get validatePostalCodeWithError() {
    return this.validatePostalCode || this.$t("CHECKOUT_ADDRESS_INVALID_POSTALCODE");
  }

  get houseNumberNotStreet() {
    return this.address.street != this.address.houseNumber ? true : "Bitte geben Sie die Hausnummer an";
  }

  @Watch("sendToInstitution")
  onSendToInstitutionChange(newVal: boolean) {
    if (!newVal) {
      this.address.institution = undefined;
    }
  }

  @Watch("address.institution")
  onInstitutionChange(newVal: string) {
    if (newVal) {
      this.sendToInstitution = true;
    }
  }
}

